
import BaseDialog from "@/components/BaseDialog";
import { i18n } from './langs'
import { 
    getIntelligentForewarnApi, deleteIntelligentForewarnApi,
    editIntelligentForewarnApi, saveIntelligentForewarnApi
} from '@/api'

/**
 * 智能预警
 * @param { string } param0 语言
 * @returns 
 */
export const EarlyWarnMixin = ({ language ='CN', page })=> {
    const { t } = i18n(language);
    const LANGUAGE_TYPE= {
        CN: '1',
        EN: '2'
    };
    const defaultParams = {
        language: LANGUAGE_TYPE[language],
        type: page,
    }
    // 
    return {
        data() {
            return {
                language,
                fieldList: [
                    'local_spend', 'total_installs_price', 'cli_price', '7_day_retention_rate',
                    '7_day_retention_users', '3_day_retention_rate','3_day_retention_users',
                    'next_day_retention_rate','next_day_retention_users','cumulative_roi',
                    'cumulative_revenue','cumulative_paying_rate','cumulative_paying_cost',
                    'cumulative_paying_users','ltv30','30_day_roi','30_day_revenue','30_day_paying_rate',
                    '30_day_paying_cost','30_day_paying_users','ltv7','7_day_roi', '7_day_revenue',
                    '7_day_paying_rate', '7_day_paying_cost', '7_day_paying_users', 'ltv3',
                    '3_day_roi', '3_day_paying_amount', '3_day_paying_rate', '3_day_paying_cost',
                    '3_day_paying_users', 'arpu', 'first_day_roi', 'first_day_revenue', 'first_day_paying_rate',
                    'first_day_paying_cost', 'first_day_paying_users', 'character_creation_rate', 'character_creation_cost',
                    'number_of_new_characters_created', 'registration_rate', 'registration_cost',
                    'number_of_registrations', 'activation_rate', 'activation_cost', 'number_of_activations'
                ],
                sovFieldList: ["impression_share","impression_rank","search_popularity"],
                earlyWarnData: {},
            }
        },
        created() {
            this.getIntelligentForewarn()
        },
        computed: {
            allFieldList() {
                return [].concat(this.fieldList, this.sovFieldList)
            },
            
            // earlyWarnFieldList() {
            //     return Object.keys(this.earlyWarnData);
            // }
        },
        methods: {
           
            async getIntelligentForewarn() {
                try {
                    const params = {
                        type: page,
                        field: this.allFieldList && this.allFieldList.join(','),
                    }
                    const { data } = await getIntelligentForewarnApi(params);
                    this.earlyWarnData = data;
                } catch (error) {
                    this.$message.error(error.info || error.message)
                }
            },
            renderEarlyWarnIcon(h, column, list) {
                if (this.allFieldList.includes(column.name)) {
                    return h('i', {
                        class: 'el-icon-setting',
                        style: {
                            'margin-left': '4px',
                            ...this.getEarlyWarnThem(column)
                        },
                        on: {
                            click: (e)=> {
                                e.preventDefault()
                                e.stopPropagation()
                                this.openEarlyWarnModal(column)
                            }
                        }
                    })
                }
                return null
            },
            getEarlyWarnThem(column) {
                if (this.allFieldList.includes(column.name)) {
                    return {
                        color: this.earlyWarnData[column.name] ? '#409EFF': '#333'
                    }
                }else {
                    return {}
                }
            },
            openEarlyWarnModal(column) {
                const onSubmit = async (params)=> {
                    params.field = column.name;
                    // 编辑
                    if (params.id) {
                        await editIntelligentForewarnApi({ ...defaultParams, ...params })
                    }else {
                        await saveIntelligentForewarnApi({ ...defaultParams, ...params })
                    };
                    await this.getIntelligentForewarn()
                    vm.close()
                };
                const removeData = async (id)=> {
                    await deleteIntelligentForewarnApi({ id });
                    await this.getIntelligentForewarn()
                    vm.close()
                }
                const defaultData = this.formatDefaultData(this.earlyWarnData[column.name] || {});
                const { vm } = earlyWarnModal({
                    title:  `${t('metric_monitoring')}：${column.display_name}`,
                    props: {
                        t, defaultData,
                        hasSovField: this.sovFieldList.includes(column.name),
                        isEN: language === 'EN'
                    },
                    cbs: {
                        onSubmit,
                        removeData
                    },
                })
            },
            formatDefaultData(data) {
                function toArr(text) {
                    return text?text.split(','):[]
                }
                return Object.assign({}, data, {
                    check_frequency_time: toArr(data.check_frequency_time),
                    notification_designated_email: toArr(data.notification_designated_email),
                })
            }
        }
    }
}

/**
 * 智能预警
 * @param {*} param0 
 * @returns 
 */
export function earlyWarnModal({ props, cbs, title }) {
    return new BaseDialog({
      component: ()=>import('./earlyWarnModal'),
      options: {
        width: '780px',
        'show-close': false,
        'close-on-click-modal': false,
        'close-on-press-escape': false,
        title
      },
      props,
      cbs
    })
  }